import { useLanguage } from '../contexts/LanguageContext';

/**
 * Money surface class: always `ads-money`; adds legacy `rtl-amount` under Arabic RTL.
 * Pair with useFormatCurrency() / MoneyText / MoneyAmount.
 */
export function useMoneyClass(extra = '') {
  const { isRTL } = useLanguage();
  const parts = ['ads-money'];
  if (isRTL) parts.push('rtl-amount');
  if (extra) parts.push(extra);
  return parts.join(' ');
}

export default useMoneyClass;
